import React from 'react';
import PropTypes from 'prop-types';

import Search from '@decisiv/iconix/lib/components/Search';
import Message from '@decisiv/ui-components/lib/components/Message';

import { EmptyStateArea } from './styles';

/**
 * Shown when a search or filter matches nothing (Figma 787:78141).
 *
 * Distinct from UsersEmptyState: that one drops the column headers and the table
 * footer, while this keeps both, because the user needs those controls to widen
 * or undo what they narrowed. That is why this renders inside the table rather
 * than in place of it.
 *
 * The design only draws the searched case, where the title quotes back the term.
 * Filters can empty the list too, so that case gets a title of its own rather
 * than an empty pair of quotes — worth confirming with design.
 */
function UsersNoMatches({ query }) {
  const title = query ? `No Matches for “${query}”` : 'No Matches';

  return (
    <EmptyStateArea>
      <Message
        color="licoriceMousse"
        icon={Search}
        size="large"
        title={title}
        variant="vertical"
      >
        Try searching for different Email or Username
      </Message>
    </EmptyStateArea>
  );
}

UsersNoMatches.propTypes = {
  /** The search term, quoted back in the title when there is one. */
  query: PropTypes.string,
};

UsersNoMatches.defaultProps = {
  query: '',
};

export default UsersNoMatches;
